// extracted by mini-css-extract-plugin
export default {"container":"Fq-z","ratingLayout":"Gq-z","ratingLabel":"Hq-z","nonInteractiveRatingLabel":"Iq-z"};